const ExpiredMessageType = {
	DEFAULT: 'default',

	// We show a special message in portuguese for expired PicPay team members
	PICPAY: 'picpay',
} as const;

export default ExpiredMessageType;
